export const isDev = !!process.env.BEEPS_DEVELOPMENT;

export const verbose = false;
